module.exports = __webpack_public_path__ + "static/media/smarthygiene_ut.05fc2051.png";